import { render, staticRenderFns } from "./SampleLayout.vue?vue&type=template&id=2954dff4&"
import script from "./SampleLayout.vue?vue&type=script&lang=js&"
export * from "./SampleLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/ARCHIVE/Source/five9/ps-droids/packages/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2954dff4')) {
      api.createRecord('2954dff4', component.options)
    } else {
      api.reload('2954dff4', component.options)
    }
    module.hot.accept("./SampleLayout.vue?vue&type=template&id=2954dff4&", function () {
      api.rerender('2954dff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/samples/SampleLayout.vue"
export default component.exports